var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFileTextHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7481",
  d: "M15 7.5v4.143c0 .219-.292.29-.417.365a2.47 2.47 0 0 0-1.283-.341c-.892.008-1.667.358-2.192 1-.6.741-.825 1.783-.616 2.866.116.595.362 1.124.677 1.585.112.162-.012.382-.209.382H5q-2.5 0-2.5-2.5V5q0-2.5 2.5-2.5h5V5a2.5 2.5 0 0 0 2.5 2.5z",
  opacity: 0.4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7481",
  d: "M12.5 7.5H15l-5-5V5q0 2.5 2.5 2.5M11.667 10.625H5.834a.625.625 0 0 1 0-1.25h5.833a.625.625 0 0 1 0 1.25m-1.875 2.708a.625.625 0 0 0-.625-.625H5.834a.625.625 0 0 0 0 1.25h3.333c.345 0 .625-.28.625-.625M17.448 15.296c-.38 1.928-2.862 3.039-2.862 3.039s-2.481-1.11-2.861-3.039c-.234-1.182.276-2.372 1.572-2.378.965-.005 1.29.953 1.29.953s.324-.957 1.289-.953c1.299.006 1.805 1.196 1.572 2.378"
})));
export default SvgFileTextHeart;